<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YJcbWQ/tc-custom/9781631956164.jpg?1695292720001" alt="This image is the cover for the book Gathering Stones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gathering Stones
      </h1>
      <p class="bookDescription body article font2">
        <b>A forty-day devotional that calls Christians to remember who God is, what He has promised, what He has instructed, and what He has done.</b><br/><br/>There were many times in the Bible when believers gathered stones as reminders of the great truths of God’s power and grace. Remembering these truths is a conscious act?an effort that provides great reward for one’s soul. Deuteronomy 4:9 (NLT) says, “But watch out! Be careful never to forget what you yourself have seen. Do not let these memories escape from your mind as long as you live! And be sure to pass them on to your children and grandchildren.” Follow the journey of Sara W. Berry as she shares some of her own “stones of remembrance” stories and inspires readers to see the miracles of God wrapped up in ordinary life. <i>Gathering Stones</i> is the perfect devotional for any need of spiritual inspiration. It encourages readers to collect their own stones of remembrance as they see Him more clearly in everyday life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara W. Berry
      </h2>
      
      <p class="authorDescription body article">Sara W. Berry is a wife, mother, and award-winning author. She has written 15 books and curricula, including bestselling non-fiction Tap Code co-written with Col. Smitty Harris and Summer of 1969 co-written with Juanita G. Floyd. Sara is married to Dr. Mont Berry and is mother of seven children and three children-in-law. She resides in Tupelo, Mississippi.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b6ceea8